import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from '../../../adapters/types'
import { RocFormData } from '../../types/RocFormData'
import { RocFormField } from '../../types/RocFormField'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { getAppointmentTimeWithTimezone } from '../../../helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from '../../../helpers.uncontrolled'

/**
 * Assessment Overview subsection adapter for ROC Assessment
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Extract appointment time with timezone support
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options.caregiverTimezone
    )

    return {
      [RocFormField.APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RocFormField.APPOINTMENT_TIME)) {
      const appointmentTime = this.getFormDataField(RocFormField.APPOINTMENT_TIME)
      const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(
        appointmentTime ?? [undefined, undefined]
      )

      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
        value: appointmentTimeValues.at(0)
      })

      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
        value: appointmentTimeValues.at(1)
      })
    }

    return mutations
  }
}
